export enum FeatureFlags {
  enableIncidentsModule = "enable-incidents-module",
  enableLogMenu = "enable-log-menu",
}
